export const ASSET_CLASSES = [
  'Buildings and Leasehold Improvements',
  'Furniture and Fixtures',
  'Machinery and Equipment',
  'Vehicles',
  'Website Development Costs',
  'Startup Costs',
  'Goodwill',
] as const

export type AssetClass = (typeof ASSET_CLASSES)[number]

export const LOCATIONS = ['Highland Park', 'River Oaks', 'G&A'] as const

const ASSET_CLASS_SET = new Set<string>(ASSET_CLASSES)

/** First segment of a QBO account FQN/name before `:`, if it is a canonical class. */
export function assetClassFromQboAccountName(accountName: string): AssetClass | '' {
  const firstSegment = (accountName.split(':')[0] ?? '').trim()
  if (ASSET_CLASS_SET.has(firstSegment)) {
    return firstSegment as AssetClass
  }
  return ''
}
